import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@klp/design';
import { getRequiredConfig } from '@klpkonsern/appconfig';

const useStyles = makeStyles((theme) => ({
    chatView: {
        position: 'absolute',
        right: '-10px',
        top: '30px',
        zIndex: 9999,
    },
    ikon: {
        filter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(132deg) brightness(103%) contrast(103%)',
    },
    button: {
        backgroundColor: theme.palette.secondary?.dark,
        '&:hover': {
            backgroundColor: theme.palette.secondary?.main,
        },
    },
}));

type VertexAiAgentProps = {
    configId: string;
    location: string;
    triggerId: string;
};

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'gen-search-widget': VertexAiAgentProps;
        }
    }
}

export default function ChatView() {
    const classes = useStyles();
    const configId = getRequiredConfig('WEBAPP_VERTEX_AI_CONFIG_ID');

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        // Dispatch a native click event to the hidden trigger element
        const element = document.getElementById('searchWidgetTriggerHidden');
        if (element) {
            const nativeClick = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            element.dispatchEvent(nativeClick);
        }
    };

    return (
        <div className={classes.chatView}>
            <Tooltip translation="chat.tooltip" title="">
                <IconButton
                    className={classes.button}
                    onClick={handleButtonClick}
                >
                    <Illustration
                        className={classes.ikon}
                        icon={IconName.CHAT}
                        klpPalette="primary"
                        klpColor="main"
                        size="medium"
                    />
                </IconButton>
            </Tooltip>
            {/* Hidden trigger element for widget activation */}
            <button
                id="searchWidgetTriggerHidden"
                style={{ display: 'none' }}
                tabIndex={-1}
                aria-hidden="true"
            />
            <gen-search-widget
                configId={configId}
                location="eu"
                triggerId="searchWidgetTriggerHidden"
            />
        </div>
    );
}
